<template>
  <div>
    <p>{{ $t('general__text__change-log') }}:</p>
    <p>{{ $t('general__text__created-date') }}: {{ createdDateFormatted }}</p>
    <p>
      {{ $t('general__text__last-modified-date') }}:
      {{ lastModifiedDateFormatted }}
    </p>
  </div>
</template>

<script>
import { getFormattedDateString } from '@/utils/date'
export default {
  name: 'OverlayProductMetaInfoBox',
  props: {
    createdDateString: {
      type: String,
      default: ''
    },
    lastModifiedDateString: {
      type: String,
      default: ''
    }
  },
  computed: {
    createdDateFormatted() {
      return getFormattedDateString(this.createdDateString)
    },
    lastModifiedDateFormatted() {
      return getFormattedDateString(this.lastModifiedDateString)
    }
  }
}
</script>
